$('.sidebar__category').on('click', function(){
  $(this).parent().toggleClass('sidebar__category-wrap--open');
});
